import _uniqueId from "lodash/uniqueId";
import * as types from '../types';
const checkExercise = (exerciseId, message, success, isLoggedIn, lastSubmittedCode) => ({
  id: exerciseId,
  isLoggedIn,
  lastSubmittedCode,
  message,
  messageId: _uniqueId(),
  success,
  type: types.CHECK_EXERCISE
});
export default checkExercise;